<template>
    <div class="text-xs font-medium grid grid-cols-10 gap-2 items-center auto-cols-max py-4 even:bg-gray-100 odd:bg-gray-200 cursor-pointer border-x-8 hover:border-x-6" :class="this.rowStyle" @click.stop="goToAuction(auction.id);">
        <div class="flex justify-center border-gray-300">
            <span @click.stop="setStarRating">
                <icon
                    class="w-5 h-5 hover:w-6 hover:h-6"
                    :name="starTeaserStyle"
                />
            </span>
        </div>
        <div class="text-center font-bold">{{ auction.attributes.lfd_nr }}</div>
        <div v-if="auction.image_url"><img :src="auction.image_url" class="w-12 h-auto mx-auto"/></div>
        <div v-else class="text-center">Kein Bild</div>
        <div class="col-span-3">
            {{$t('pages.auctions.control.components.auction_list_item.a_id')}} {{ auction.external_id }}<br/>
            {{ auction.name }}<br/>
            {{$t('pages.auctions.control.components.auction_list_item.b_nr')}} {{ auction.article_id }}</div>
        <div class="text-center">{{  auction.article_quantity }}</div>
        <div class="text-center">{{ auction.attributes.purchase_price | toCurrency }}</div>
        <div class="text-center">{{ auction.attributes.avg | toCurrency }}</div>
        <div>
            <status :data="getAuctionState(auction)"/>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import Status from '@/Shared/Status';
    import AuctionState from "@/mixins/AuctionState";
    import { Link } from '@inertiajs/vue2';
    import Icon from '@/Shared/Icon';

    export default {
        name: "AuctionListItem",
        mixins: [AuctionState],
        components: {
            Status,
            Link,
            Icon
        },
        props: {
            auction: Object,
            active: Object,
            ranking: Number,
            view: String
        },
        data() {
            return {
                enabled: false,
                starTeaserState: null,
                starTimer: null
            }
        },
        mounted() {
          this.starTeaserState = parseInt(this.auction.star_teaser);
        },
        methods: {
            setStarRating() {
                if (this.starTimer) {
                    clearTimeout(this.starTimer);
                }
                if ((this.starTeaser + 1) > 2) {
                    this.starTeaserState = 0;
                } else {
                    this.starTeaserState++;
                }
                let obj = this;
                this.starTimer = setTimeout(function() {
                    obj.$emit('starTeaser', obj.auction.id, obj.starTeaserState)
                }, 500);
            },
            getDuration() {
                return moment().startOf('day').seconds(this.auction.duration).format('mm:ss');
            },
            goToAuction(auctionId) {
                this.$emit('aclick', auctionId);
                this.$inertia.visit(route('auctions.control', {auction: auctionId, view: 'control'}), {
                   preserveState: true,
                   preserveScroll: true,
                   only: ['runtime','auction','stocks','view','runningAuctions']
                });
            }
        },
        computed: {
            starTeaser() {
                if (this.starTeaserState !== null) {
                    return this.starTeaserState;
                }
                return this.auction.star_teaser;
            },
            starTeaserStyle() {
                if (0 === parseInt(this.starTeaser)) {
                    return 'star';
                }
                if (1 === parseInt(this.starTeaser)) {
                    return 'star-solid';
                }
                return 'star-solid-gold';
            },
            isAuctionRunning() {
                return this.isRunning(this.auction) || this.isPreview(this.auction);
            },
            rankingStyle() {
                return {
                    'bg-gray-400': (this.active.id === this.auction.id),
                    'bg-green-700 text-white': this.isAuctionRunning,
                }
            },
            rowStyle() {
                return {
                    'animate-pulse': this.isAuctionRunning,
                    'border-gray-600': (this.active.id === this.auction.id && this.view === 'control' && !this.isAuctionRunning),
                    'border-green-600': (this.view === 'control' && this.isAuctionRunning),
                }
            }
        }
    }
</script>
